angular.module('bizmetryApp').controller('CreateProfileWizardController',
  function ($scope, $mdDialog, $mdToast, ProfileService, TemplateInstanceService,
            ReferenceDataService, dialogService) {

      console.log ('----> CreateProfileWizardController !!!');
    // ─── Wizard model ────────────────────────────────────────────────────────

    $scope.wizard = {
      stepIndex:  0,
      totalSteps: 4,
      steps: [
        { label: 'Profile Source' },
        { label: 'Details'        },
        { label: 'Identity'       },
        { label: 'Review'         }
      ],

      // Step 1
      selection: null,

      // Step 3 – Identity (name/project/description)
      profile: {
        name:        '',
        projectName: '',
        description: ''
      },
      existingProfileNames: [],   // lowercased profile names, preloaded for dedupe
      existingProjectNames: [],   // lowercased project names, preloaded for numerator lookup
      nameAlreadyExists:    false,
      loadingNames:         true,
      _identityTouched:     false,   // true once the user manually edits the name field
      _identityGenerated:   false,   // true once auto-generated at least once
      _timeSerial:          null,    // cached per-generation serial (fresh on regenerate)

      // Step 2 – Clone
      availableProfiles: [],
      selectedProfile:   null,
      loadingProfiles:   false,
      cloneSearch:       '',

      // Step 2 – Master template
      availableTemplates: [],
      selectedTemplate:   null,
      loadingTemplates:   false,

      // Step 2 – Empty template
      selectedLanguage:       null,
      selectedBusinessDomain: null,
      selectedTechnologyStack: null,
      languages:       [],
      businessDomains: [],
      technologyStacks: [],
      loadingRefData:  false,

      // Step 4
      creating: false
    };

    // ─── Step 1 options ──────────────────────────────────────────────────────

    $scope.options = [
      {
        value: 'clone-existing',
        icon:  'content_copy',
        label: 'Clone from an existing profile',
        help:  'Duplicate an existing profile and adjust settings as needed.'
      },
      {
        value: 'empty-template',
        icon:  'description',
        label: 'Start from an empty template',
        help:  'Create a brand-new profile with blank settings.'
      },
      {
        value: 'master-template',
        icon:  'layers',
        label: 'Start from a master template',
        help:  'Use a curated master template tailored to your technology stack and platform.'
      }
    ];

    // ─── Dialog cancel ───────────────────────────────────────────────────────

    $scope.onCancel = function () {
      dialogService.showDecisionDialog(
        'Cancel Profile Creation',
        'Are you sure you want to cancel? All configuration progress will be lost.'
      ).then(function (decision) {
        if (decision === 'proceed') {
          $mdDialog.cancel();
        }
      });
    };

    // ─── Stepper navigation ──────────────────────────────────────────────────

    $scope.gotoStep = function (idx) {
      if (idx <= $scope.wizard.stepIndex) {
        $scope.wizard.stepIndex = idx;
      }
    };

    $scope.goBack = function () {
      if ($scope.wizard.stepIndex > 0) {
        $scope.wizard.stepIndex--;
      }
    };

    // ─── Step 1 → Step 2 (Details, with lazy data load) ─────────────────────

    $scope.continueFromSource = function () {
      if (!$scope.wizard.selection) return;

      // Re-confirming the source invalidates any previously generated
      // identity and clears the fields it populated, so the next visit to
      // the Identity step always recomputes from scratch for the (possibly
      // new) source type — otherwise stale values from a different flow
      // (e.g. a cloned profile's inherited description) could leak through.
      $scope.wizard._identityGenerated = false;
      $scope.wizard._identityTouched   = false;
      $scope.wizard._timeSerial        = null;
      $scope.wizard.profile = { name: '', projectName: '', description: '' };

      $scope.wizard.stepIndex = 1;

      switch ($scope.wizard.selection) {
        case 'clone-existing':
          _loadProfiles();
          break;
        case 'master-template':
          _loadMasterTemplates();
          break;
        case 'empty-template':
          _loadReferenceData();
          break;
      }
    };

    // ─── Step 2 → Step 3 (Identity) ─────────────────────────────────────────

    $scope.continueFromDetails = function () {
      if (!$scope.isDetailsValid()) return;
      $scope._generateProfileIdentity();
      $scope.wizard.stepIndex = 2;
    };

    // ─── Step 3 → Step 4 (Review) ────────────────────────────────────────────

    $scope.continueFromIdentity = function () {
      if (!$scope.isIdentityValid()) return;
      $scope.wizard.stepIndex = 3;
    };

    // ─── Validation helpers ──────────────────────────────────────────────────

    $scope.isDetailsValid = function () {
      switch ($scope.wizard.selection) {
        case 'clone-existing':
          return !!$scope.wizard.selectedProfile;
        case 'master-template':
          return !!$scope.wizard.selectedTemplate;
        case 'empty-template':
          return !!(
            $scope.wizard.selectedLanguage        &&
            $scope.wizard.selectedBusinessDomain  &&
            $scope.wizard.selectedTechnologyStack
          );
        default:
          return false;
      }
    };

    $scope.isIdentityValid = function () {
      var w = $scope.wizard;
      return !!(
        w.profile.name        && w.profile.name.trim()        &&
        w.profile.projectName && w.profile.projectName.trim() &&
        w.profile.description && w.profile.description.trim()
      ) && !w.nameAlreadyExists && !w.loadingNames;
    };

    // ─── Data loaders (private) ──────────────────────────────────────────────

    function _loadProfiles() {
      if ($scope.wizard.availableProfiles.length) return; // already loaded
      $scope.wizard.loadingProfiles = true;

      ProfileService.getAllProfiles({ size: 200 })
        .then(function (response) {
          $scope.wizard.availableProfiles =
            (response.data && response.data.profiles) ? response.data.profiles : [];
        })
        .catch(function (error) {
          console.error('❌ Error loading profiles for clone:', error);
          $scope.wizard.availableProfiles = [];
          dialogService.showErrorDialog('Load Error', 'Could not load profiles. Please try again.');
        })
        .finally(function () {
          $scope.wizard.loadingProfiles = false;
        });
    }

    function _loadMasterTemplates() {
      if ($scope.wizard.availableTemplates.length) return;
      $scope.wizard.loadingTemplates = true;

      TemplateInstanceService.getAllMasterTemplates()
        .then(function (response) {
          $scope.wizard.availableTemplates =
            (response.data && response.data.length) ? response.data : [];
        })
        .catch(function (error) {
          console.error('❌ Error loading master templates:', error);
          $scope.wizard.availableTemplates = [];
          dialogService.showErrorDialog('Load Error', 'Could not load templates. Please try again.');
        })
        .finally(function () {
          $scope.wizard.loadingTemplates = false;
        });
    }

    function _loadReferenceData() {
      if ($scope.wizard.languages.length) return;
      $scope.wizard.loadingRefData = true;

      var promises = [
        ReferenceDataService.getReferenceData('LANGUAGE'),
        ReferenceDataService.getReferenceData('BUSINESS_DOMAIN'),
        ReferenceDataService.getReferenceData('BUSINESS_TECHNOLOGY')
      ];

      Promise.all(promises.map(function (p) { return p.catch(function () { return { data: [] }; }); }))
        .then(function (results) {
          $scope.wizard.languages       = results[0].data || [];
          $scope.wizard.businessDomains = results[1].data || [];
          $scope.wizard.technologyStacks = results[2].data || [];
          $scope.$applyAsync();
        })
        .finally(function () {
          $scope.wizard.loadingRefData = false;
        });
    }

    // ─── Profile name dedupe check ───────────────────────────────────────────
    // Preloaded upfront (independent of the clone-list loader above, which is
    // lazy and only triggered for the clone-existing flow) so the check is
    // available regardless of which source type the user picks.

    // Kept around so identity generation (below) can wait on it — without
    // this, a fast user reaching the Identity step before the fetch
    // resolves would see the numerator start over at -0001 even when
    // higher numbers already exist for that domain/stack combination.
    var _existingNamesPromise = ProfileService.getAllProfiles({ size: 1000 })
      .then(function (response) {
        var list = (response.data && response.data.profiles) ? response.data.profiles : [];
        $scope.wizard.existingProfileNames = list.map(function (p) {
          return (p.profileName || '').trim().toLowerCase();
        });
        $scope.wizard.existingProjectNames = list.map(function (p) {
          return (p.profileProjectName || '').trim().toLowerCase();
        });
      })
      .catch(function () {
        $scope.wizard.existingProfileNames = [];
        $scope.wizard.existingProjectNames = [];
      })
      .finally(function () { $scope.wizard.loadingNames = false; });

    // Called on every keystroke in the name field
    $scope.onNameChange = function () {
      var trimmed = ($scope.wizard.profile.name || '').trim().toLowerCase();
      $scope.wizard.nameAlreadyExists = trimmed.length > 0 &&
        $scope.wizard.existingProfileNames.indexOf(trimmed) !== -1;
    };

    // Marks the identity as manually edited so auto-generation won't
    // clobber it if the user revisits this step later.
    $scope.onIdentityFieldEdited = function () {
      $scope.wizard._identityTouched = true;
      $scope.onNameChange();
    };

    // ─── Name generation ──────────────────────────────────────────────────────
    // The generated identity depends on the chosen profile source:
    //  - clone-existing:   inherits name/project/description from the source
    //                      profile — name becomes "Copy of <source name>".
    //  - empty-template:   name = projectSlug-contextSlug-timeSerial, where
    //                      context is the chosen language/business-domain/
    //                      tech-stack; project = domain-stack-NNNN.
    //  - master-template:  name = templateAcronym-contextSlug-timeSerial
    //                      (acronym from the template's own name), context
    //                      and project come from the template's own
    //                      language/bizDomain/bizTechStack metadata, and
    //                      description is inherited from the template.
    // The user can still edit these fields afterwards; once they touch the
    // name, we stop overwriting it on subsequent auto-generation passes
    // unless they explicitly hit "Regenerate".

    function _slug(str, maxLen) {
      return (str || '')
        .toString()
        .trim()
        .replace(/[^a-zA-Z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .substring(0, maxLen || 40);
    }

    function _contextSlug(parts) {
      return parts
        .filter(function (p) { return !!p; })
        .map(function (p) { return _slug(p, 30); })
        .filter(function (p) { return !!p; })
        .join('-');
    }

    function _emptyTemplateContextSlug() {
      var w = $scope.wizard;
      return _contextSlug([
        w.selectedLanguage        ? w.selectedLanguage.refObjectLabel        : null,
        w.selectedBusinessDomain  ? w.selectedBusinessDomain.refObjectLabel  : null,
        w.selectedTechnologyStack ? w.selectedTechnologyStack.refObjectLabel : null
      ]);
    }

    function _masterTemplateContextSlug() {
      var t = $scope.wizard.selectedTemplate;
      if (!t) { return ''; }
      return _contextSlug([t.language, t.bizDomain, t.bizTechStack]);
    }

    // Acronym from the first letter of every word — keeps long master
    // template names (e.g. "Comprehensive Pharmacy Operations Template
    // English" → "CPOTE") from blowing up the generated profile name.
    function _acronym(str) {
      return (str || '')
        .toString()
        .trim()
        .split(/\s+/)
        .map(function (word) { return word.charAt(0).toUpperCase(); })
        .join('');
    }

    function _timeSerial() {
      return Date.now().toString(36);
    }

    // Zero-pads a running numerator, e.g. 1 → "0001".
    function _pad4(n) {
      var s = n.toString();
      while (s.length < 4) { s = '0' + s; }
      return s;
    }

    // Next available "-NNNN" numerator for a given project-name base
    // (domain-stack slug), scanned against existing project names so
    // repeated domain/stack combinations don't collide — e.g. "fintech-kafka"
    // already used as "fintech-kafka-0001" yields "0002" next.
    function _nextProjectNumerator(baseLower) {
      var maxN = 0;
      (($scope.wizard.existingProjectNames) || []).forEach(function (name) {
        if (name.indexOf(baseLower + '-') !== 0) { return; }
        var suffix = name.substring(baseLower.length + 1);
        if (/^\d+$/.test(suffix)) {
          var n = parseInt(suffix, 10);
          if (n > maxN) { maxN = n; }
        }
      });
      return _pad4(maxN + 1);
    }

    // Builds "<domain>-<stack>-NNNN" for the empty-template and
    // master-template flows, where domain/stack come from whichever
    // source is relevant to that flow (user selection vs. template
    // metadata — see call sites below).
    function _domainStackProjectName(domainLabel, stackLabel) {
      var base = _contextSlug([domainLabel, stackLabel]);
      if (!base) { return ''; }
      return base + '-' + _nextProjectNumerator(base.toLowerCase());
    }

    // Auto-generates the identity from the current selections — but only
    // the FIRST time the Identity step is reached. No-op on subsequent
    // visits (whether the user touched the name or not) so that simply
    // going back-and-forth between steps doesn't keep changing the name
    // out from under them via a fresh timestamp. Explicit regeneration is
    // still available via $scope.regenerateIdentity() (the UI button).
    $scope._generateProfileIdentity = function () {
      if ($scope.wizard._identityGenerated || $scope.wizard._identityTouched) { return; }
      $scope.regenerateIdentity();
    };

    // Public entry point (bound to the Regenerate button and called by
    // _generateProfileIdentity above). Always waits for the existing
    // profiles/projects fetch to finish first — otherwise the numerator
    // in _domainStackProjectName could be computed against a still-empty
    // list and wrongly restart at -0001 for a domain/stack that already
    // has higher numbers in use.
    $scope.regenerateIdentity = function () {
      _existingNamesPromise.finally(function () {
        _doRegenerateIdentity();
        $scope.$applyAsync();
      });
    };

    function _doRegenerateIdentity() {
      var w = $scope.wizard;
      w._timeSerial = _timeSerial();

      switch (w.selection) {

        case 'clone-existing':
          if (w.selectedProfile) {
            w.profile.name        = _slug('Copy of ' + (w.selectedProfile.profileName || ''), 100);
            w.profile.projectName = w.selectedProfile.profileProjectName || '';
            w.profile.description = w.selectedProfile.profileDescription || '';
          }
          break;

        case 'empty-template':
          w.profile.projectName = _domainStackProjectName(
            w.selectedBusinessDomain  ? w.selectedBusinessDomain.refObjectLabel  : '',
            w.selectedTechnologyStack ? w.selectedTechnologyStack.refObjectLabel : ''
          );
          w.profile.name = [_slug(w.profile.projectName, 40), _emptyTemplateContextSlug(), w._timeSerial]
            .filter(function (p) { return !!p; })
            .join('-')
            .substring(0, 100);
          break;

        case 'master-template':
          var templateAcronym = w.selectedTemplate ? _acronym(w.selectedTemplate.templateName) : 'TPL';
          w.profile.name = [templateAcronym, _masterTemplateContextSlug(), w._timeSerial]
            .filter(function (p) { return !!p; })
            .join('-')
            .substring(0, 100);
          w.profile.description = w.selectedTemplate ? (w.selectedTemplate.templateDesc || '') : '';
          w.profile.projectName = _domainStackProjectName(
            w.selectedTemplate ? w.selectedTemplate.bizDomain     : '',
            w.selectedTemplate ? w.selectedTemplate.bizTechStack  : ''
          );
          break;
      }

      w._identityTouched   = false;
      w._identityGenerated = true;
      $scope.onNameChange();
    }

    // ─── Tree preview (double-click on master template) ─────────────────────

    $scope.openTreeDialog = function (template) {
      $mdDialog.show({
        controller:          'TreeTemplateViewController',
        templateUrl:         'template/treeView/tree-template-view.html',
        parent:              angular.element(document.body),
        escapeToClose:       false,
        clickOutsideToClose: true,
        multiple:            true,
        locals:              { templateInstance: template }
      });
    };

    // ─── Create profile ──────────────────────────────────────────────────────

    $scope.createProfile = function () {
      if ($scope.wizard.creating) return;
      $scope.wizard.creating = true;

      var w = $scope.wizard;

      var payload = {
        profileName:        w.profile.name,
        profileDescription: w.profile.description,
        profileProject:     w.profile.projectName,
        createFrom:         w.selection,
        master_template: {
          id:   w.selectedTemplate ? w.selectedTemplate.templateId   : null,
          name: w.selectedTemplate ? w.selectedTemplate.templateName : null
        },
        source_profile: {
          id:   w.selectedProfile ? w.selectedProfile.id          : null,
          name: w.selectedProfile ? w.selectedProfile.profileName : null
        },
        new_profile: {
          language: {
            id:   w.selectedLanguage ? w.selectedLanguage.refId           : null,
            name: w.selectedLanguage ? w.selectedLanguage.refObjectLabel  : null
          },
          bizDomain: {
            id:   w.selectedBusinessDomain ? w.selectedBusinessDomain.refId          : null,
            name: w.selectedBusinessDomain ? w.selectedBusinessDomain.refObjectLabel : null
          },
          bizTechStack: {
            id:   w.selectedTechnologyStack ? w.selectedTechnologyStack.refId          : null,
            name: w.selectedTechnologyStack ? w.selectedTechnologyStack.refObjectLabel : null
          }
        }
      };

      ProfileService.createProfile(payload)
        .then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent('✅ Profile "' + payload.profileName + '" created successfully!')
              .position('top right')
              .hideDelay(3000)
          );
          $mdDialog.hide();
        })
        .catch(function (error) {
          var msg = (error && error.data && error.data.message)
            ? error.data.message
            : 'An unexpected error occurred. Please try again.';
          dialogService.showErrorDialog('Profile Creation Error', msg);
        })
        .finally(function () {
          $scope.wizard.creating = false;
        });
    };

  });
